function getSaleParam() {
  var saleValue = null;
  // Check normal query string ?sale=XXXX
  var searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('sale')) {
    saleValue = searchParams.get('sale');
  }
  // Check hash query #/?sale=XXXX
  if (!saleValue && window.location.hash) {
    var hash = window.location.hash;
    if (hash.includes('sale=')) {
      var hashQuery = hash.split('?')[1];
      if (hashQuery) {
        var hashParams = new URLSearchParams(hashQuery);
        if (hashParams.has('sale')) {
          saleValue = hashParams.get('sale');
        }
      }
    }
  }
  return saleValue;
}
var saleParam = getSaleParam();
if (saleParam) {
  localStorage.setItem('sale_type', saleParam);
}
